import { Box, Grid, TextField, RadioGroup } from "@mui/material";

import RadioLabel from "./utils/RadioLabel";
import StyledRadio from "./utils/StyledRadio";
import FilterController from "./utils/FilterController";
import CustomSelectV2 from "../CustomSelectV2";
import DateTimePicker from "../DateTimePicker";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadCounties, loadCurrencies } from "../../Swift/state/actions";

const BasicFilters = ({ values, errors, setValues, handleChange, type }) => {
  const dispatch = useDispatch();
  const countries = useSelector((state) => state.swiftMessages.countries.items);
  const currencies = useSelector(
    (state) => state.swiftMessages.currencies.items
  );

  useEffect(() => {
    dispatch(loadCounties());
    dispatch(loadCurrencies());
  }, [dispatch]);

  console.log(errors.amountFromTo);
  return (
    <>
      <Grid item>
        <Grid container>
          <Grid item xs={4}>
            <FilterController
              label="Date/Time range"
              error={errors.dateTimeFrom || errors.dateTimeTo}
            >
              <DateTimePicker
                onChange={(value) => {
                  setValues({ ...values, ...value });
                }}
                dateTimeFrom={values.dateTimeFrom}
                dateTimeTo={values.dateTimeTo}
                isInvalid={!!errors.dateTimeFrom || !!errors.dateTimeTo}
                type={type}
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ marginRight: "1rem", width: "calc(8px + 100%/3)" }}
      >
        <FilterController label="Countries" error={errors.countries}>
          <CustomSelectV2
            label=""
            options={countries}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, countries) => {
              setValues({
                ...values,
                countries: countries.map((country) => country.code),
              });
            }}
            value={values.countries.map((code) =>
              countries.find((country) => country.code === code)
            )}
            width="100%"
            background="#fff"
            multiple
            limitTags={4}
            isInvalid={!!errors.countries}
            disableCloseOnSelect
          />
        </FilterController>
      </Grid>
      <Grid item>
        <Grid container>
          <Grid
            item
            xs={4}
            sx={{ marginRight: "1rem" }}
            error={errors.currencies}
          >
            <FilterController label="Currency">
              <CustomSelectV2
                label=""
                options={currencies}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, currencies) => {
                  setValues({
                    ...values,
                    currencies: currencies.map((currency) => currency.code),
                  });
                }}
                value={values.currencies.map((code) =>
                  currencies.find((currency) => currency.code === code)
                )}
                width="100%"
                background="#fff"
                multiple
                limitTags={4}
                isInvalid={!!errors.currencies}
                disableCloseOnSelect
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController
              label="Amount range"
              error={
                errors.amountFrom || errors.amountTo || errors.amountFromTo
              }
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  name="amountFrom"
                  value={values.amountFrom || ""}
                  type="number"
                  size="small"
                  placeholder="from"
                  sx={{ background: "#fff" }}
                  error={!!errors.amountFrom || !!errors.amountFromTo}
                  onChange={handleChange}
                />
                <TextField
                  name="amountTo"
                  value={values.amountTo || ""}
                  type="number"
                  size="small"
                  placeholder="to"
                  sx={{ background: "#fff" }}
                  error={!!errors.amountTo || !!errors.amountFromTo}
                  onChange={handleChange}
                />
              </Box>
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <FilterController
          label="Message Standing/Status"
          error={errors.standing}
        >
          <RadioGroup
            row
            name="standing"
            onChange={handleChange}
            value={values.standing}
          >
            <RadioLabel value="ALL" control={<StyledRadio />} label="All" />
            <RadioLabel value="ACK" control={<StyledRadio />} label="ACK" />
            <RadioLabel value="NACK" control={<StyledRadio />} label="NACK" />
          </RadioGroup>
        </FilterController>
      </Grid>
    </>
  );
};

export default BasicFilters;
